/* eslint-disable no-nested-ternary */
import { Masonry } from '@mui/lab'
import { SvgIcon, Tooltip } from '@mui/material'
import { min } from 'moment'
import Link from 'next/link'
import { Dispatch, SetStateAction, useState } from 'react'
import missingFile from '../../assets/images/missing-file.png'
import { formatDaysToDeliveryDisplay } from '../../hooks/displayTools'
import { ResponsiveImageGridItem } from '../Image/ResponsiveImageGridItem'
// eslint-disable-next-line import/no-cycle
import { Icon } from '../Layout/Icon'
import { DeliveryCalendarPopover } from '../Product/DeliveryCalendarPopover/DeliveryCalendarPopover'
// eslint-disable-next-line import/no-cycle
import { MegaMenuSubCardGrid } from './MegaMenuSubCardGrid'
import { MegaMenuItem } from './NewMegaMenuHeaderTabs'

type MegaMenuSubHeaderTabProps = {
  menuItems?: MegaMenuItem[]
  className?: string
  url?: string
  setShowMenu: Dispatch<SetStateAction<boolean>>
  setValue?: Dispatch<SetStateAction<string>>
  showHeader?: boolean
  onSelect?: (item: MegaMenuItem) => void
  onBack?: () => void
  animateIn?: boolean
  label?: string
}

export function NewMegaMenuSubHeaderTab(props: MegaMenuSubHeaderTabProps) {
  const {
    menuItems,
    className,
    url,
    setShowMenu,
    setValue,
    showHeader,
    onSelect,
    onBack,
    animateIn,
    label,
  } = props
  const [selectedItem, setSelectedItem] = useState<MegaMenuItem | null>(menuItems?.[0] ?? null)

  const formatMOQ = (moq) => {
    if (!moq) return ''
    const num = parseFloat(String(moq).replace(/,/g, ''))
    return Number.isNaN(num) ? '' : num.toLocaleString('en-US')
  }

  return (
    menuItems &&
    menuItems?.length > 0 && (
      <div
        className={`flex h-fit min-h-screen w-full flex-col items-start justify-start gap-x-10 overflow-auto border-[1px] border-b-2 border-t-0 border-20-grey bg-pure-white px-5 lg:px-10 py-5 shadow-2xl md:grid md:h-max md:min-h-max md:w-[55%] md:min-w-[780px] md:max-w-[700px] md:grid-cols-2  md:gap-x-5 lg:gap-x-10 ${className}`}
      >
        <div
          className={`hidden sm:flex h-auto flex-col gap-y-3 md:h-auto md:gap-y-3 md:pl-5 ${
            animateIn ? 'animate-slide-fade-settle' : 'opacity-0'
          }`}
        >
          {onBack && (
            <button
              onClick={onBack}
              key='back'
              type='button'
              className='mb-5 flex w-auto items-center justify-start gap-3 text-black hover:text-bright-templi-purple active:text-bright-templi-purple-active lg:min-w-[170px]'
            >
              <Icon name='arrow_back' className='font-bold lg:text-[20px]' />

              <h3>
                <span className='Type-XXL-Medium md:Type-XXL-Medium text-start lg:whitespace-nowrap'>
                  Back
                </span>
              </h3>
            </button>
          )}

          {/* {showHeader && !onBack && (
            <div className='mb-5 flex flex-col gap-y-3'>
              <Link
                onClick={() => setShowMenu(false)}
                key='bestseller'
                href='search/q/sort/bestsellers/dir/desc'
                className='w-auto text-black hover:text-bright-templi-purple active:text-bright-templi-purple-active lg:min-w-[170px]'
              >
                <h3>
                  <span className='Type-XXXL-Medium md:Type-XXL-Medium text-start lg:whitespace-nowrap'>
                    Best Sellers
                  </span>
                </h3>
              </Link>
            </div>
          )} */}

          {menuItems?.map((category) => (
            <div
              key={category?.url}
              className='flex min-w-[170px] flex-col items-start justify-start gap-1'
            >
              {category?.children?.length > 0 && (
                <button
                  onClick={() => onSelect?.(category)}
                  key={category.name}
                  type='button'
                  onMouseEnter={() => setSelectedItem(category)}
                  className='w-auto text-start text-black hover:text-bright-templi-purple active:text-bright-templi-purple-active lg:min-w-[170px]'
                >
                  <h3>
                    <span className='Type-XL-Regular md:Type-XXL-Regular whitespace-nowrap text-start lg:whitespace-nowrap'>
                      {category.name}
                    </span>
                  </h3>
                </button>
              )}
              {category?.url && category?.children?.length < 1 && (
                <Link
                  onClick={() => setShowMenu(false)}
                  key={category.name}
                  href={category?.url}
                  onMouseEnter={() => setSelectedItem(category)}
                  className='w-auto text-black hover:text-bright-templi-purple active:text-bright-templi-purple-active lg:min-w-[170px]'
                >
                  {category?.name?.toLowerCase()?.indexOf('view all') > -1 ? (
                    <h3 className='mt-5 flex items-center justify-start gap-3'>
                      <span className='Type-XXL-Regular md:Type-XXL-Regular text-start lg:whitespace-nowrap'>
                        {category.name}
                      </span>
                      <Icon name='arrow_forward' className='font-medium lg:text-[20px]' />
                    </h3>
                  ) : (
                    <h3>
                      <span className='Type-XXL-Regular md:Type-XXL-Regular text-start lg:whitespace-nowrap'>
                        {category.name}
                      </span>
                    </h3>
                  )}
                </Link>
              )}
              {!category.url && category?.children?.length < 1 && (
                <h3 onMouseEnter={() => setSelectedItem(category)}>
                  <span className='Type-XXL-Regular md:Type-XXL-Regular w-full text-start text-black'>
                    {category.name}
                  </span>
                </h3>
              )}
            </div>
          ))}
        </div>

        <div className='ml-5 hidden items-start justify-end gap-5 md:flex'>
          <div key={selectedItem?.url} className='w-full text-black'>
            {selectedItem?.children?.length ? (
              <button
                onClick={() => onSelect?.(selectedItem)}
                className='cursor-pointer'
                type='button'
              >
                <ResponsiveImageGridItem
                  src={selectedItem?.image_url ?? missingFile?.src}
                  alt={selectedItem?.name ?? ''}
                  aspect='3/5'
                  className=' mb-4 h-full min-w-[180px] max-w-[180px]'
                  borderRadius='12px'
                  hasHoverEffect
                />
              </button>
            ) : (
              <Link
                href={selectedItem?.url ?? ''}
                onClick={() => setShowMenu(false)}
                className='group flex items-center justify-start text-bright-templi-purple'
              >
                <ResponsiveImageGridItem
                  src={selectedItem?.image_url ?? missingFile?.src}
                  alt={selectedItem?.name ?? ''}
                  aspect='3/5'
                  className=' mb-4 h-full min-w-[180px] max-w-[180px]'
                  borderRadius='12px'
                />
              </Link>
            )}
            <h2>
              {selectedItem?.children?.length ? (
                <button
                  onClick={() => onSelect?.(selectedItem)}
                  className=' mb-10 flex cursor-pointer items-center justify-start text-black hover:text-bright-templi-purple active:text-bright-templi-purple-active'
                  type='button'
                >
                  <span className='md:Type-XXL-Regular md:Type-XXL-Regular text-start'>
                    {selectedItem?.name}
                  </span>
                </button>
              ) : (
                <Link
                  href={selectedItem?.url ?? ''}
                  onClick={() => setShowMenu(false)}
                  className=' mb-10 flex flex-col items-start justify-center gap-y-3 text-black'
                >
                  <span className='md:Type-XXL-Regular md:Type-XXL-Regular text-start hover:text-bright-templi-purple active:text-bright-templi-purple-active md:whitespace-nowrap'>
                    {selectedItem?.name}
                  </span>
                  {selectedItem?.moq && (
                    <span className='md:Type-XXL-Regular md:Type-XXL-Regular text-start'>
                      Minimum: {formatMOQ(selectedItem?.moq)}
                    </span>
                  )}
                  {selectedItem?.production_time && (
                    <div className='flex items-center gap-2'>
                      <span className='md:Type-XXL-Regular md:Type-XXL-Regular text-start'>
                        Est. Delivery:{' '}
                        {formatDaysToDeliveryDisplay(selectedItem?.production_time ?? '')}
                      </span>
                      <DeliveryCalendarPopover
                        production_time={Number(selectedItem.production_time)}
                      />
                      <Tooltip
                        title='Estimated delivery dates are not guaranteed delivery dates. It assumes your proof is approved within 24 hours. Rush services may be available. We will make every effort possible to deliver by this date.'
                        arrow
                      >
                        <SvgIcon sx={{ fontSize: 16, color: '#555', cursor: 'pointer' }}>
                          <path d='M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' />
                        </SvgIcon>
                      </Tooltip>
                    </div>
                  )}
                </Link>
              )}
            </h2>
          </div>
        </div>
        <div className='flex items-start justify-start md:hidden w-full'>
          <MegaMenuSubCardGrid
            menuItems={menuItems}
            onSelect={onSelect}
            onBack={onBack}
            label={label}
          />
        </div>
      </div>
    )
  )
}
